import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from '@/app/core/auth/auth.service';
import { injectAssistantSession } from '@/app/core/auth/assistant-session';

/**
 * Attaches the EG-issued bearer token to outbound API calls.
 *
 * ⚠️ Preskače zahteve ka asistentskom servisu — njih obrađuje `egAssistantInterceptor` iz biblioteke.
 * Bez tog preskoka bi ProTax-ov token otišao na InternalGptService, gde ga taj servis odbija **TIHO**:
 * GraphQL endpoint je anoniman i vraća 200 sa `errors` telom umesto 401, pa otkaz izgleda kao greška u
 * podacima. Prepoznavanje je `ownsRequest`, koji poredi RAZREŠENE origin-e, ne prefikse stringova.
 *
 * ⚠️ Kad je asistent iskljucen sesije nema, pa preskoka nema — i to je ispravno: tada nijedan zahtev ni ne
 * ide ka asistentskom servisu.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.headers.has('Authorization')) return next(req);
    if (injectAssistantSession()?.ownsRequest(req.url)) {
        return next(req);
    }
    const auth = inject(AuthService);
    return from(auth.getAccessToken()).pipe(switchMap((token) => next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req)));
};
